import { useAtomValue } from "jotai";
import { transferTypesAtom } from "@design-lab/entities/transfer-types";

export { type TransferType } from "@design-lab/entities/transfer-types";

/**
 * Hook that provides access to transfer types from the global entity state
 * The data is loaded once at the entity level and shared across components
 * @returns Transformed transfer types with loading and error states
 */
export function useTransferTypes() {
  const state = useAtomValue(transferTypesAtom);

  return {
    transferTypes: state.context.transferTypes,
    loading: state.context.loading,
    error: state.context.error,
    defaultTransferTypeId: state.context.defaultTransferTypeId
  };
}
